export default "__VITE_ASSET__62f92272__"